export const getSale = (
  freeSessions: number,
  paySessions: number,
  fee: number
) => {
  const allSessions = freeSessions + paySessions;

  return Number(allSessions * fee).toFixed(2);
};
